(function () {
  const videos = Array.from(document.querySelectorAll('[data-bagveda-real-life-media] video'));
  if (!videos.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);

  const sourceFor = (video) => {
    const mobile = video.getAttribute('data-src-mobile');
    const desktop = video.getAttribute('data-src');
    if (isMobile && mobile) return mobile;
    return desktop || mobile || '';
  };

  const hydrate = (video) => {
    const src = sourceFor(video);
    if (!src || video.getAttribute('data-hydrated') === 'true') return;
    video.setAttribute('data-hydrated', 'true');
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('muted', '');
    video.preload = isMobile ? 'metadata' : 'auto';
    video.src = src;
    video.load();
  };

  const playVideo = (video) => {
    if (prefersReducedMotion) return;
    hydrate(video);
    video.muted = true;
    const play = video.play();
    if (play && typeof play.catch === 'function') play.catch(() => {});
  };

  const pauseVideo = (video) => {
    if (!video.paused) video.pause();
  };

  videos.forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.removeAttribute('autoplay');
  });

  if (prefersReducedMotion) return;

  if (!('IntersectionObserver' in window)) {
    videos.forEach(playVideo);
    return;
  }

  const visible = new Map();

  const syncMobilePlayback = () => {
    if (!isMobile) return;
    let best = null;
    let bestRatio = 0;
    visible.forEach((ratio, video) => {
      if (ratio > bestRatio) {
        best = video;
        bestRatio = ratio;
      }
    });
    videos.forEach((video) => {
      if (video === best && bestRatio >= 0.45) playVideo(video);
      else pauseVideo(video);
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          visible.set(video, entry.intersectionRatio);
          if (isMobile) {
            if (entry.intersectionRatio >= 0.2) hydrate(video);
          } else if (entry.intersectionRatio >= 0.35) {
            playVideo(video);
          }
        } else {
          visible.delete(video);
          pauseVideo(video);
        }
      });
      if (isMobile) syncMobilePlayback();
    },
    {
      root: isMobile ? document.querySelector('.bagveda-pdp-real-life__grid') : null,
      rootMargin: isMobile ? '0px 40% 0px 40%' : '0px 0px 10% 0px',
      threshold: [0, 0.2, 0.35, 0.5, 0.75, 1],
    }
  );

  videos.forEach((video) => observer.observe(video));

  if (isMobile && !saveData) {
    const first = videos[0];
    if (first) hydrate(first);
  }
})();
